/**
 * La flèche « Retour à l'accueil » s'affiche-t-elle sur cette page ?
 *
 * Jamais sur la page d'enregistrement en ligne (décision de Morgan) : servie sur le domaine de lien
 * (`/f/check-in/{slug}`), la racine de ce domaine ne connaît aucune société et répond 404. Ni sur l'accueil lui-même.
 * Les autres pages la gardent.
 *
 * @param {string} pathname
 * @returns {boolean}
 */
export function isReturnToHomeShown(pathname) {
    return pathname !== '/' && pathname.indexOf('check-in') === -1;
}
